function FacebookIcon() {
  return (
    <svg className="h-5 w-5 fill-current" viewBox="0 0 25.151 25.151" aria-hidden="true">
      <path d="M4.592,0A4.582,4.582,0,0,0,0,4.592V20.558A4.582,4.582,0,0,0,4.592,25.15h8.653V15.318h-2.6v-3.54h2.6V8.754c0-2.376,1.536-4.558,5.075-4.558a21.442,21.442,0,0,1,2.492.138L20.729,7.64s-1.081-.01-2.259-.01c-1.276,0-1.48.588-1.48,1.564v2.585h3.842l-.168,3.54H16.99v9.833h3.569a4.582,4.582,0,0,0,4.592-4.592V4.592A4.582,4.582,0,0,0,20.559,0Z" />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg className="h-5 w-5 fill-current" viewBox="0 0 25.152 25.151" aria-hidden="true">
      <path
        d="M15.575,3c-3.415,0-3.843.015-5.184.075a9.255,9.255,0,0,0-3.052.585A6.427,6.427,0,0,0,3.66,7.338a9.272,9.272,0,0,0-.585,3.052C3.014,11.732,3,12.16,3,15.575s.014,3.843.075,5.184a9.255,9.255,0,0,0,.585,3.052A6.425,6.425,0,0,0,7.339,27.49a9.272,9.272,0,0,0,3.052.585c1.341.06,1.77.075,5.184.075s3.843-.015,5.184-.075a9.255,9.255,0,0,0,3.052-.585,6.425,6.425,0,0,0,3.679-3.679,9.272,9.272,0,0,0,.585-3.052c.06-1.341.075-1.77.075-5.184s-.015-3.843-.075-5.184a9.255,9.255,0,0,0-.585-3.052A6.425,6.425,0,0,0,23.813,3.66a9.272,9.272,0,0,0-3.052-.585C19.418,3.015,18.99,3,15.575,3m0,2.266c3.358,0,3.755.013,5.08.073a6.986,6.986,0,0,1,2.336.433,4.163,4.163,0,0,1,2.387,2.387,6.979,6.979,0,0,1,.433,2.335c.06,1.327.073,1.723.073,5.082s-.013,3.755-.073,5.08a7.031,7.031,0,0,1-.433,2.336,4.163,4.163,0,0,1-2.387,2.387,6.979,6.979,0,0,1-2.335.433c-1.325.06-1.723.073-5.082.073s-3.757-.013-5.08-.073a7.031,7.031,0,0,1-2.336-.433,4.163,4.163,0,0,1-2.387-2.387,6.935,6.935,0,0,1-.433-2.335c-.06-1.327-.073-1.723-.073-5.082s.013-3.755.073-5.08a6.986,6.986,0,0,1,.433-2.336A4.163,4.163,0,0,1,8.158,5.772a6.935,6.935,0,0,1,2.335-.433c1.327-.06,1.723-.073,5.082-.073m0,14.5a4.191,4.191,0,1,1,4.192-4.191,4.191,4.191,0,0,1-4.192,4.191m0-10.649a6.457,6.457,0,1,0,6.457,6.457,6.457,6.457,0,0,0-6.457-6.457M23.8,8.863a1.509,1.509,0,1,1-1.509-1.509A1.509,1.509,0,0,1,23.8,8.863"
        transform="translate(-3 -3)"
        fillRule="evenodd"
      />
    </svg>
  );
}

interface SocialLinksProps {
  facebook?: string;
  instagram?: string;
  className?: string;
}

function externalUrl(value?: string): string | null {
  if (!value) return null;
  try {
    const url = new URL(value.trim());
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : null;
  } catch {
    return null;
  }
}

export function SocialLinks({ facebook, instagram, className }: SocialLinksProps) {
  const links = [
    { label: 'Facebook', href: externalUrl(facebook), Icon: FacebookIcon },
    { label: 'Instagram', href: externalUrl(instagram), Icon: InstagramIcon },
  ].filter((link): link is typeof link & { href: string } => link.href !== null);

  if (links.length === 0) return null;

  return (
    <div className={`flex items-center gap-2 ${className ?? ''}`}>
      {links.map(({ label, href, Icon }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          className="border-border-subtle bg-bg-canvas text-fg-secondary hover:border-accent hover:text-accent focus-visible:ring-accent inline-flex h-11 w-11 items-center justify-center rounded-full border transition-colors focus-visible:outline-none focus-visible:ring-2"
        >
          <Icon />
        </a>
      ))}
    </div>
  );
}
